module.exports = __webpack_public_path__ + "img/tab_item02.c74e028c.png";